import * as React from "react";
import { SlidersHorizontal } from "lucide-react";

export function FilterPanel({
  title,
  children,
  actions,
}: {
  readonly title: string;
  readonly children: React.ReactNode;
  readonly actions: React.ReactNode;
}) {
  const headingId = React.useId();

  return (
    <section
      className="rounded-lg border border-border-subtle bg-surface p-5 shadow-[var(--elevation-1)]"
      aria-labelledby={headingId}
      data-filter-panel
    >
      <h2 id={headingId} className="text-heading-small flex items-center gap-2">
        <SlidersHorizontal
          className="size-4 text-brand-strong"
          aria-hidden="true"
        />
        {title}
      </h2>
      <div className="mt-5 grid gap-4">{children}</div>
      <div className="mt-6 grid gap-2">{actions}</div>
    </section>
  );
}
